module.exports = __webpack_public_path__ + "static/media/provider-awcmsexy.c5dab798.png";